import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import styles from './Alert.module.scss'

type AlertType = 'info' | 'warning' | 'error' | 'success'

interface AlertProps {
  type?: AlertType
  title?: string
  children: ReactNode
  className?: string
}

const slertTypeStyles: Record<AlertType, string> = {
  info: styles.info,
  warning: styles.warning,
  error: styles.error,
  success: styles.success,
}

export const Alert: FC<AlertProps> = ({ type = 'info', title, children, className }) => {
  return (
    <div className={classNames(styles.alert, slertTypeStyles[type], className)}>
      {title && <p className={styles.title}>{title}</p>}
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default Alert
